import type { PlayerInput } from "./types";

/** Twelve commands cover 200 ms of input history at the default 60 Hz. */
export const INPUT_HISTORY_LIMIT = 12;
const encoder = new TextEncoder();

/** Split history at command boundaries; MTU pressure must never erase a tick. */
export function inputPackets(
  inputs: readonly PlayerInput[],
  maxBytes = Number.POSITIVE_INFINITY,
  matchId?: string,
): Uint8Array[] {
  const packets: Uint8Array[] = [];
  let batch: PlayerInput[] = [];
  let packet: Uint8Array | undefined;
  for (const input of inputs) {
    const candidate = encoder.encode(
      JSON.stringify({
        type: "input_bundle",
        matchId,
        inputs: [...batch, input],
      }),
    );
    if (batch.length === INPUT_HISTORY_LIMIT || candidate.length > maxBytes) {
      if (packet) packets.push(packet);
      batch = [];
      packet = undefined;
    }
    batch.push(input);
    packet =
      batch.length === 1
        ? encoder.encode(
            JSON.stringify({ type: "input_bundle", matchId, inputs: batch }),
          )
        : candidate;
    if (packet.length > maxBytes)
      throw new Error("Input command exceeds the transport MTU");
  }
  if (packet) packets.push(packet);
  return packets;
}
